import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '../../../key-registry'
import { fromConsignmentResponse } from '../models/mapper'
import { Consignment } from '../models/types'
import { fetchConsignmentV2 } from './http'

export async function fetchConsignment(
  params: { transitOperationId: number },
  opts?: { signal?: AbortSignal },
): Promise<Consignment> {
  const response = await fetchConsignmentV2(params, opts)
  return fromConsignmentResponse(response)
}

export function useFetchConsignment(transitOperationId: number | null) {
  return useQuery({
    queryKey: QueryKeys.consignment.detailsByParams({ transitOperationId }),
    enabled: !!transitOperationId,
    queryFn: ({ signal }) => fetchConsignment({ transitOperationId: transitOperationId as number }, { signal }),
  })
}
